import { DrinksIndexer } from "@dcc/types/drinks";
import { GenderIndexer, Gender } from "@dcc/types/gender";

export enum BingeFrequency {
  Never,
  LessThanMonthly,
  Monthly,
  Weekly,
  DailyOrAlmostDaily
}

export type DrinksDescription = DrinksIndexer<number>;

export type BingDrinkAmounts = GenderIndexer<DrinksDescription>;

export const bingeDrinkAmounts: BingDrinkAmounts = {
  [Gender.Male]: {
    beer: 6,
    pint: 3.5,
    wine: 3.5,
    spirit: 8
  },
  [Gender.Female]: {
    beer: 4.5,
    pint: 2.5,
    wine: 2.5,
    spirit: 6
  }
};
